import { render } from "./PageLoading.vue?vue&type=template&id=245bd9cd&scoped=true"
import script from "./PageLoading.vue?vue&type=script&lang=js"
export * from "./PageLoading.vue?vue&type=script&lang=js"

import "./PageLoading.vue?vue&type=style&index=0&id=245bd9cd&lang=scss&scoped=true"

import exportComponent from "/var/www/kl_keepjoy_work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245bd9cd"]])

export default __exports__